export default __webpack_public_path__ + "static/media/024-swimsuit.4d31ac24.svg";